export class ContextMenuEntry {
  text: string;
}
